<div class="scad-drag-area">
  <div class="scad-drag-area__body">
    <div class="scad-drag-area__wrapper">
      <div class="scad-drag-area__drag-section">
        <div class="scad-drag-area__drag-actoin">
          <div><img src="/assets/images/svg/square.svg" alt="" /></div>
          <div><img src="/assets/images/svg/star.svg" alt="" /></div>
          <div><img src="/assets/images/svg/tick.svg" alt="" /></div>

          <button class="scad-drop-btn-secondary" [matMenuTriggerFor]="menu">
            <span class="arrow"><img src="/assets/images/svg/play.svg" alt="" /> </span>
            <span
              ><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.66669 6.66663L9.9333 13.3333L15.1429 6.66663" stroke="#CCDDF1" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                </span>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item>Item 1</button>
            <button mat-menu-item>Item 2</button>
          </mat-menu>

        </div>

        <div id="drawflow" #drawflow (dragover)="_flowBuilder.onDragOver($event)" (drop)="_flowBuilder.onDrop($event)">
        </div>
      </div>


      <app-scad-right-sidebar [hidden]="!_flowBuilder.showSettings"></app-scad-right-sidebar>


    </div>
</div>



<!--
      <div class="scad-drag-area__drag-scroll "> <img src="/assets/images/svg/drow.svg" alt="" /> </div>
      <div class="scad-drag-area__btn scad-drag-area__source" style="top: 100px; left: 50px;"> <img src="/assets/images/svg/sub-menu-2.svg" alt="" /> </div>
          <div class="box scad-drag-area__btn scad-drag-area__target " style="left: 200px; top: 100px;" >
            <div class="scad-drag-area__btn scad-drag-area__target-color">
              <img src="/assets/images/svg/tabler_filter.svg" alt="" />
            </div>
          </div>

          <div class="scad-drag-area__tooltip" style="left: 200px; top: 100px;"> source-name </div>

        </div> -->
